angular.module('impactx.deliverynote').controller('DeliveryNoteSerialNumberCtrl', [
    '$scope',
    'TranslationService',
    'dataGen',
    '$mdDialog',
    '$timeout',
    'trns',
    'item',
    'readOnly',
    DeliveryNoteSerialNumberCtrl]);

function DeliveryNoteSerialNumberCtrl($scope, TranslationService, dataGen, $mdDialog, $timeout, trns, item, readOnly) {
    $timeout(function () {
        var lastEc = angular.element(document.querySelector(".serial-number-content"));
        lastEc[0].scrollTop = lastEc[0].scrollHeight;
    });
    $scope.trns = trns;
    $scope.item = item;
    $scope.readOnly = readOnly;
    $scope.editIndex = {value: 0};
    var self = this;

    if (!$scope.item.dniInfoItems || $scope.item.dniInfoItems.length === 0) {
        $scope.item.dniInfoItems = [];
    }
    else if ($scope.item.dniInfoItems.length > 0 && $scope.item.dniInfoItems.length < $scope.item.deliveredAmount.value) {
        if ($scope.item.dniInfoItems[$scope.item.dniInfoItems.length - 1].value) {
            $scope.item.dniInfoItems.push({value: ""});
        }
        $scope.editIndex.value = $scope.item.dniInfoItems.length - 1;
    }
    else if ($scope.item.dniInfoItems.length < $scope.item.deliveredAmount.value) {
        $scope.editIndex.value = $scope.item.dniInfoItems.length - 1;
    }
    else {
        $scope.item.dniInfoItems.length = $scope.item.deliveredAmount.value;
        $scope.editIndex.value = $scope.item.dniInfoItems.length - 1;
    }

    this.forward = function () {
        if (self.showForwardButton())
        {
            if ($scope.editIndex.value + 1 >= $scope.item.dniInfoItems.length) {
                $timeout(function () {
                    var lastEc = angular.element(document.querySelector(".serial-number-content"));
                    lastEc[0].scrollTop = lastEc[0].scrollHeight;
                });
                $scope.item.dniInfoItems.push({value: ""});
            }
            $scope.editIndex.value++;
        }
    };

    this.more = function () {
        $timeout(function () {
            var lastEc = angular.element(document.querySelector(".serial-number-content"));
            lastEc[0].scrollTop = lastEc[0].scrollHeight;
        });
        $scope.editIndex.value = $scope.item.dniInfoItems.length;
        $scope.item.dniInfoItems.push({value: ""});
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.confirm = function () {
        $mdDialog.hide({item: $scope.item});
    };

    this.showForwardButton = function () {
        return $scope.editIndex.value + 1 < parseInt($scope.item.deliveredAmount.value)
    };

    this.showMoreButton = function () {
        return $scope.editIndex.value + 1 < $scope.item.dniInfoItems.length &&
            $scope.item.dniInfoItems.length < parseInt($scope.item.deliveredAmount.value)
    };

    this.setEditIndex = function (index) {
        $scope.editIndex.value = index;
    };

    this.deleteAll = function () {
        $scope.item.dniInfoItems = [];
        $scope.editIndex.value = 0;
    }
}

